import type { ReactNode } from "react";

import * as NavigationMenu from "@radix-ui/react-navigation-menu";

import * as theme from "./PageNavMenu.css";

export interface PageNavMenuProps {
    "aria-label": string;
    children: ReactNode;
}

export function PageNavMenu({
    "aria-label": ariaLabel,
    children,
}: PageNavMenuProps) {
    return (
        <NavigationMenu.Root
            orientation="vertical"
            aria-label={ariaLabel}
            className={theme.root}
        >
            <NavigationMenu.List className={theme.sections}>
                {children}
            </NavigationMenu.List>
        </NavigationMenu.Root>
    );
}
